import store from '@/js/store';
import constants from '@/js/constant';
const { CACHE_KEYS } = constants;

const saveData = async (key, data) => {
    if (data === undefined || data === null) {
        return;
    }
    localStorage.setItem(key, JSON.stringify(data));
    store.dispatch('saveValue', { key: key, value: data });
}

const getData = async (key, init_data = "") => {
    const cachedData = JSON.parse(localStorage.getItem(key));
    if (cachedData === null) {
        store.dispatch('saveValue', { key: key, value: init_data });
        return init_data;
    }
    store.dispatch('saveValue', { key: key, value: cachedData });
    return cachedData;
}

const resetData = async () => {
    for (const targetKey of CACHE_KEYS) {
        localStorage.removeItem(targetKey);
    }
}


export default {
    saveData,
    getData,
    resetData,
}
